import * as React from "react";

import { Outlet } from "react-router-dom";

import { SecurityArea } from "../auth/index.ts";
import { ApplicationsRouteGuard } from "../components/RouteGuard/ApplicationsRouteGuard.tsx";
import { EngagementRouteGuard, ProjectRouteGuard, UserRouteGuard } from "../components/RouteGuard/index.ts";
import { UserPrivilegeType } from "../types/enums/index.ts";

export function userGuard(privilegeType: UserPrivilegeType, element: React.ReactNode) {
    return {
        element: <UserRouteGuard privilegeType={privilegeType} render={element} />,
    };
}
export function userGuardWithOutlet(privilegeType: UserPrivilegeType, element: React.ReactNode) {
    return {
        element: (
            <UserRouteGuard
                privilegeType={privilegeType}
                render={
                    <>
                        {element}
                        <Outlet />
                    </>
                }
            />
        ),
    };
}

export function engagementGuard(securityArea: SecurityArea, element: React.ReactNode) {
    return {
        element: <EngagementRouteGuard securityArea={securityArea} render={element} />,
    };
}
export function engagementGuardWithOutlet(securityArea: SecurityArea, element: React.ReactNode) {
    return {
        element: (
            <EngagementRouteGuard
                securityArea={securityArea}
                render={
                    <>
                        {element}
                        <Outlet />
                    </>
                }
            />
        ),
    };
}

export function projectGuard(securityArea: SecurityArea, element: React.ReactNode) {
    return {
        element: <ProjectRouteGuard securityArea={securityArea} render={element} />,
    };
}
export function projectGuardWithOutlet(securityArea: SecurityArea, element: React.ReactNode) {
    return {
        element: (
            <ProjectRouteGuard
                securityArea={securityArea}
                render={
                    <>
                        {element}
                        <Outlet />
                    </>
                }
            />
        ),
    };
}

export function applicationGuard(applicationArea: string, securityArea: SecurityArea, element: React.ReactNode) {
    return {
        element: <ApplicationsRouteGuard securityArea={securityArea} render={element} applicationArea={applicationArea} />,
    };
}
export function applicationGuardWithOutlet(applicationArea: string, securityArea: SecurityArea, element: React.ReactNode) {
    return {
        element: (
            <ApplicationsRouteGuard
                securityArea={securityArea}
                applicationArea={applicationArea}
                render={
                    <>
                        {element}
                        <Outlet />
                    </>
                }
            />
        ),
    };
}
